import { createViewModel, MapView } from '@qpr/map';
import React, { useContext, useEffect } from 'react';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import useHierarchyUrlParams from '../hooks/useHierarchyUrlParams';
import usePropertyViewAttributes from '../hooks/usePropertyViewAttributes';
import FilterContext from '../modules/Filter/components/FilterContext';

const MapPage = () => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  const hierarchyRequest = useHierarchyUrlParams();
  const attributeInfo = usePropertyViewAttributes();

  const viewModel = createViewModel(hierarchyRequest);

  return (
    <FilterContext>
      <MapView viewModel={viewModel} attributeInfo={attributeInfo} />
    </FilterContext>
  );
};

export default MapPage;
